import React, { memo } from "react";
import cls from "classnames";

import styles from "./styles.scss";

const HomeSkeleton: React.FC = () => {
  return (
    <div className={styles.page}>
      <div className={cls(styles.skeleton, styles.banner)} />
      <div className={cls(styles.skeleton, styles.wrapper, styles.mb8)}>
        <div className={cls(styles.skeleton, styles.price, styles.mb10)} />
        <div className={cls(styles.skeleton, styles.next_promotion, styles.mb10)} />
        <div className={cls(styles.skeleton, styles.name, styles.mb6)} />
        <div className={cls(styles.skeleton, styles.rate)} />
      </div>
      <div className={cls(styles.skeleton, styles.wrapper, styles.mb8)}>
        <div className={cls(styles.list_item, styles.list_item_border, styles.mb16)}>
          <div className={cls(styles.skeleton, styles.list_item_name, styles.mb12)} />
          <div className={cls(styles.skeleton, styles.list_item_sub)} />
        </div>
        <div className={cls(styles.list_item, styles.list_item_border, styles.mb16)}>
          <div className={cls(styles.skeleton, styles.list_item_name, styles.mb12)} />
          <div className={cls(styles.skeleton, styles.list_item_sub)} />
        </div>
        <div className={cls(styles.list_item)}>
          <div className={cls(styles.skeleton, styles.list_item_name, styles.mb12)} />
          <div className={cls(styles.skeleton, styles.list_item_sub, styles.mb12)} />
          <div className={cls(styles.skeleton, styles.list_item_sub_content)} />
        </div>
      </div>
      <div className={styles.fix_button_box}>
        <div className={cls(styles.fix_button, styles.add_card_btn)}></div>
        <div className={styles.fix_button}></div>
      </div>
    </div>
  );
};

export default memo(HomeSkeleton);
